module.exports = __webpack_public_path__ + "components/home-header/static/header-1--large@2x-b25e081ec7139710f6bc1d68c8d70dbb.jpg";